<template>
  <div class="content">
    <alert-component />
    <div class="card">
      <div class="card-header bg-white">
        <div class="card-title">
          <h5 class="font-weight-semibold">
            <i class="fas fa-unlock-alt mr-2" />{{ $t("Password") }}
          </h5>
          <div>{{ $t("It's a good idea to use a strong password that you don't use elsewhere.") }}</div>
        </div>
      </div>
      <div class="card-body">
        <password-component
          :valuetime="valuetime"
          :stringtime="stringtime"
        />
      </div>
    </div>
    <div class="card">
      <div class="card-header bg-white">
        <div class="card-title">
          <h5 class="font-weight-semibold">
            <i class="fas fa-envelope mr-2" />{{ $t("Secondary Email") }}
          </h5>
          <div>
            {{ $t("A secondary email can be used to restore access to your account. Security notification are also sent to this email.") }}
          </div>
        </div>
      </div>
      <div class="card-body">
        <secondary-email-component
          :secondary_email="user.secondary_email"
          :user-status="userStatus"
          :button_secondery="button_secondery"
        />
      </div>
    </div>
    <div class="card">
      <div class="card-header bg-white header-elements-lg-inline">
        <div class="card-title">
          <h5 class="font-weight-semibold">
            <i class="fas fa-cogs mr-2" />{{ $t("Devices") }}
          </h5>
          <div>{{ $t("You're currently logged in on these devices. If you don't recognize a device, log out to keep your account secure") }}</div>
        </div>
        <div class="header-elements text-nowrap pl-lg-3 px-xl-3">
          <h6 class="mr-3">
            <a
              href="javascript:void(0)"
              @click="confirmLogoutAll"
            ><u>{{ $t("Logout all devices") }}</u></a>
          </h6>
        </div>
      </div>
      <div class="card-body">
        <devices-component />
      </div>
    </div>
    <div class="card">
      <div class="card-header bg-white">
        <div class="card-title">
          <h5 class="font-weight-semibold">
            <i class="fa-solid fa-heart-crack mr-2" />{{ $t("Account Removal") }}
          </h5>
          <div>
            {{ $t("Delete account means you will not be able to access this account anymore.") }}
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="bg-white header-elements-md-inline">
          <div class="pl-xl-4 mb-3 mb-md-0">
            <span>{{ $t("Account cannot recover your information after you deleted.") }}</span>
          </div>
          <div class="header-elements pr-xl-5">
            <button
              type="button"
              @click="deleteAccount()"
              class="btn btn-outline-normal nowrap"
            >
              {{ $t('Delete Account') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      id="ModalChangePassword"
      class="modal fade"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
    >
      <modal-change-password-component :refer-code="referCode" />
    </div>
    <div
      id="ModalNewPassword"
      class="modal fade"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
    >
      <modal-new-password-component :refer-code="referCode" />
    </div>
    <div
      id="ModalAddSecondaryEmail"
      class="modal fade"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
    >
      <modal-add-secondary-email-component
        :userid="user.id"
        :currentemail="user.email"
      />
    </div>

    <modal-delete-account :user-data="user" />
  </div>
</template>

<script>
//components
import AlertComponent from '../Alert';
import DevicesComponent from './Devices';
import PasswordComponent from './Password';
import SecondaryEmailComponent from './SecondaryEmail';
import CentralApi from '@/services/endpoint/central.service';
import ModalNewPasswordComponent from './ModalNewPassword.vue';
import ModalChangePasswordComponent from './ModalChangePassword';
import ModalAddSecondaryEmailComponent from './ModalAddSecondaryEmail';

import { convertTimezone } from "@/common/tenancy/convertTimezone";

import ModalDeleteAccount from './ModalDeleteAccount';

export default {
    components: {
        AlertComponent,
        DevicesComponent,
        PasswordComponent,
        SecondaryEmailComponent,
        ModalNewPasswordComponent,
        ModalChangePasswordComponent,
        ModalAddSecondaryEmailComponent,
        ModalDeleteAccount,
    },
    data() {
        return {
            userStatus: true,
            valuetime:'',
            stringtime:'',
            loggedDevices:'',
            button_secondery:'',
            tenantCnt: 0,
            last_password: null,
            referCode : [],
            user : {
              id : null,
              secondary_email : null
            }
        }
    },
    methods: {
        async getUser() {

            this.userStatus = false;
            const request = await CentralApi.Auth.getUser('?without=profileData&tenants_cnt=true&last_password=true');
            const data = await request.data.data
      
            this.user = data
            this.last_password = data.last_password;

            this.referCode = data.promotion_item_coupon_id ? data.promotion_item_coupon_id : [];

            if (this.user.secondary_email) {
                this.user.secondary_email = this.user.secondary_email;
                this.button_secondery = 'Edit secondary email';
            } else {
                this.user.secondary_email = 'You do not have a secondary email.';
                this.button_secondery = 'Add secondary email';
            }

            this.userStatus = true;
            const today = data.password_updated_at ? new Date(convertTimezone.utcToLocal(data.password_updated_at)) : new Date(convertTimezone.utcToLocal(data.created_at));
            const endDate = new Date();
            const referrent =  endDate - today;
            if (referrent >= 31536000000) {
                this.valuetime = parseInt(referrent / 31536000000);
                this.stringtime = 'years';
            } else if (referrent >= 2592000000) {
                this.valuetime = parseInt(referrent / 2592000000);
                this.stringtime = 'months';
            } else if (referrent >= 604800000) {
                this.valuetime = parseInt(referrent / 604800000);
                this.stringtime = 'weeks';
            } else if (referrent >= 86400000) {
                this.valuetime = parseInt(referrent / 86400000);
                this.stringtime = 'days';
            } else if (referrent >= 3600000) {
                this.valuetime = parseInt(referrent / 3600000);
                this.stringtime = 'hours';
            } else if (referrent >= 60000) {
                this.valuetime = parseInt(referrent / 60000);
                this.stringtime = 'minutes';
            } else if (referrent >= 1000) {
                this.valuetime = parseInt(referrent / 1000);
                this.stringtime = 'second';
            } else {
                this.valuetime = 1;
                this.stringtime = 'second';
            }
        },
        confirmLogoutAll() {
            this.$swal.fire({
                title: this.$t('Log out all devices?'),
                icon: 'warning',
                iconColor: '#FF7043',
                html: this.$t("You are about to log out of") +" "+ (this.loggedDevices+1) +" "+ this.$t('devices') + this.$t(",including your current devices"),
                showCancelButton: true,
                confirmButtonText:  this.$t('Confirm'),
                confirmButtonColor: "#1F88E5",
                cancelButtonText:  this.$t('Cancel'),
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-primary mr-2',
                    cancelButton: 'btn btn-outline-normal'
                },
                focusConfirm: false

            }).then((result) => {
              if (result.isConfirmed) {

                let params = {
                    user_id: this.user.id,
                };

                var self = this;
                CentralApi.Auth.logoutAllDevices(params).then(function(res) {
                   location.reload();
                }).catch((error) => {
                    console.log(error, 'catch');
                });

              }
          })
        },

        deleteAccount() {
            if (this.user.tenants_cnt <= 0) {
                $('#account-deletion-modal').modal();
                
            } else {
                this.$swal.fire({
                    icon: 'warning',
                    title: this.$t('Cannot Delete Account'),
                    html: this.$t("Please leave or delete all stores before delete your account."),
                    focusConfirm: true,
                    confirmButtonText: '<i class="fas fa-check-circle mr-2"></i>'+this.$t('OK'),
                    iconColor: '#FF7043',
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: 'btn btn-primary mr-2',
                    },
                })
                
            }
        },
    },
    mounted() {
        this.getUser();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/central/account/security/Index.vue